<template>
  <drr
    :id="ID"
    :x="parseInt(Left)"
    :y="parseInt(Top)"
    :w="parseInt(Width)"
    :h="parseInt(Height)"
    :angle="parseInt(Angle)"
    :aspectRatio="false"
    :z="0"
    :selectable="Enabled"
    v-on:resizestop="resize"
    v-on:dragstop="drag"
    v-on:rotatestop="rotate"
    class="componenteJuncao"
  >
    <div class="center" v-if="Type == 'JUNCAOL'">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        :width="Width"
        :height="Height"
        viewBox="0 0 100 100"
        version="1.1"
        :id="`${this.ID}-svg-juncao`"
        inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
        sodipodi:docname="cuved_union_cano_sats.svg"
      >
        <defs id="defs5359">
          <linearGradient
            gradientTransform="matrix(1.3211704,0,0,1.2681309,-171.18085,135.16106)"
            inkscape:collect="always"
            xlink:href="#linearGradient4683"
            id="linearGradient4685"
            x1="198.0585"
            y1="57.863068"
            x2="164.50136"
            y2="90.114868"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          />
          <linearGradient inkscape:collect="always" id="linearGradient4683">
            <stop
              style="stop-color:#0669b2;stop-opacity:1;"
              offset="0"
              id="stop4679"
            />
            <stop
              style="stop-color:#00779f;stop-opacity:1"
              offset="1"
              id="stop4681"
            />
          </linearGradient>
        </defs>
        <sodipodi:namedview
          id="base"
          pagecolor="#ffffff"
          bordercolor="#666666"
          borderopacity="1.0"
          inkscape:pageopacity="0.0"
          inkscape:pageshadow="2"
          inkscape:zoom="0.35"
          inkscape:cx="7.7662276"
          inkscape:cy="559.70892"
          inkscape:document-units="mm"
          inkscape:current-layer="layer1"
          showgrid="false"
          inkscape:window-width="1366"
          inkscape:window-height="705"
          inkscape:window-x="-8"
          inkscape:window-y="79"
          inkscape:window-maximized="1"
        />
        <metadata id="metadata5362">
          <rdf:RDF>
            <cc:Work rdf:about="">
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
              <dc:title></dc:title>
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <g
          inkscape:label="Camada 1"
          inkscape:groupmode="layer"
          id="layer1"
          transform="translate(0,-197)"
        >
          <path
            style="opacity:1;vector-effect:none;fill:url(#linearGradient4685);fill-opacity:1;stroke:none;stroke-width:0.64718956;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
            d="m 2e-6,197.00005 v 55.48242 H 6.60341 v -3.04398 h 24.768894 14.781174 v 17.49522 23.728 h -3.16104 V 297 h 57.00756 v -6.33829 h -2.91117 v -53.68618 -11.98263 -6.6e-4 c 0,-0.42322 -0.0107,-0.84371 -0.0328,-1.26151 -0.0877,-1.67144 -0.34849,-3.29715 -0.76601,-4.86184 -0.1044,-0.39113 -0.21908,-0.77805 -0.34274,-1.16124 -0.24738,-0.7666 -0.53198,-1.5166 -0.85342,-2.24843 -0.16064,-0.36581 -0.33094,-0.72688 -0.50931,-1.08325 -0.71356,-1.42552 -1.56647,-2.77336 -2.54251,-4.02762 -0.4879,-0.62698 -1.0067,-1.23055 -1.5539,-1.8087 v -6.5e-4 c -0.27367,-0.28915 -0.55479,-0.57185 -0.84248,-0.848 -0.86302,-0.82837 -1.78794,-1.59697 -2.76782,-2.29953 h -7e-4 c -0.65319,-0.46831 -1.33055,-0.90788 -2.03043,-1.31523 h -6.9e-4 c -0.69991,-0.40736 -1.4219,-0.78347 -2.16428,-1.12587 h -7e-4 c -1.85625,-0.85602 -3.83865,-1.50258 -5.91453,-1.9083 h -6.9e-4 c -1.24546,-0.24338 -2.52454,-0.40016 -3.83015,-0.46331 h -6.9e-4 c -0.4353,-0.0211 -0.87335,-0.0315 -1.31427,-0.0315 H 58.637188 31.372224 6.60333 V 197 Z"
            id="rect4637"
            inkscape:connector-curvature="0"
            inkscape:label="curved_union"
          />
        </g>
      </svg>
      <!-- <p>{{ Nome }}</p> -->
    </div>

    <div class="center" v-else-if="Type == 'JUNCAOT'">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        :width="Width"
        :height="Height"
        viewBox="0 0 100 70"
        version="1.1"
        :id="`${this.ID}-svg-juncao`"
        inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
        sodipodi:docname="triple_union_cano_sats.svg"
      >
        <defs id="defs5938">
          <linearGradient
            gradientTransform="matrix(0.88367614,0,0,0.88504699,-5.907311,40.531135)"
            inkscape:collect="always"
            xlink:href="#linearGradient4736"
            id="linearGradient4730"
            gradientUnits="userSpaceOnUse"
            x1="59.719215"
            y1="14.773782"
            x2="60.935883"
            y2="127.15653"
            spreadMethod="reflect"
          />
          <linearGradient id="linearGradient4736" inkscape:collect="always">
            <stop
              id="stop4732"
              offset="0"
              style="stop-color:#0669b2;stop-opacity:1;"
            />
            <stop
              style="stop-color:#00779f;stop-opacity:1"
              offset="0.5"
              id="stop4738"
            />
            <stop
              id="stop4734"
              offset="1"
              style="stop-color:#00779f;stop-opacity:1"
            />
          </linearGradient>
        </defs>
        <sodipodi:namedview
          id="base"
          pagecolor="#ffffff"
          bordercolor="#666666"
          borderopacity="1.0"
          inkscape:pageopacity="0.0"
          inkscape:pageshadow="2"
          inkscape:zoom="0.7"
          inkscape:cx="-16.929602"
          inkscape:cy="335.62296"
          inkscape:document-units="mm"
          inkscape:current-layer="layer1"
          showgrid="false"
          inkscape:window-width="1366"
          inkscape:window-height="705"
          inkscape:window-x="-8"
          inkscape:window-y="79"
          inkscape:window-maximized="1"
        />
        <metadata id="metadata5941">
          <rdf:RDF>
            <cc:Work rdf:about="">
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
              <dc:title></dc:title>
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <g
          inkscape:label="Camada 1"
          inkscape:groupmode="layer"
          id="layer1"
          transform="translate(0,-227)"
        >
          <path
            inkscape:connector-curvature="0"
            id="path4658"
            d="m 0,227.00003 v 38.72152 h 4.342306 v -2.34168 h 26.92102 v 29.27108 H 28.925269 V 297 H 67.58682 v -4.34905 h -2.25495 v -29.27108 h 30.32582 v 2.34168 H 100 v -38.72152 h -4.34231 v 2.25708 c -30.64071,-0.13609 -64.140422,-0.009 -91.315384,8.9e-4 V 227 Z"
            style="opacity:1;vector-effect:none;fill:url(#linearGradient4730);fill-opacity:1;stroke:none;stroke-width:0.44218066;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
            inkscape:label="triple_union"
          />
        </g>
      </svg>
      <!-- <p>{{ Nome }}</p> -->
    </div>
  </drr>
</template>

<script>
import drr from "@minogin/vue-drag-resize-rotate";
import datas from "../services/datas";
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Juncao",
  components: {
    drr
  },
  props: {
    ID: { type: String, default: "0" },
    Nome: { type: String, default: "Juncao" },
    Status: { type: String, default: "0" },
    Top: { type: String, default: "0" },
    Left: { type: String, default: "0" },
    Width: { type: String, default: "100" },
    Height: { type: String, default: "100" },
    Angle: { type: String, default: "0" },
    Type: { type: String, default: "" },
    Enabled: { type: Boolean, default: false }
  },
  data() {
    return {
      vWidth: { type: String, default: "50" },
      vHeight: { type: String, default: "24" }
    };
  },
  methods: {
    rotate(pos) {
      let id = this.ID;
      if (Math.abs(pos.angle) >= 0 && Math.abs(pos.angle) < 45) pos.angle = 0;
      else if (Math.abs(pos.angle) >= 45 && Math.abs(pos.angle) < 90)
        pos.angle = 90;
      else if (Math.abs(pos.angle) >= 90 && Math.abs(pos.angle) < 180)
        pos.angle = 180;
      else if (Math.abs(pos.angle) >= 180 && Math.abs(pos.angle) < 360)
        pos.angle = 270;
      let el = document.getElementById(`${this.ID}`);
      el.style.transform = `rotate(${pos.angle}deg)`;
      datas
        .salvarAngulo(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | ANGLE: ${pos.angle} | TOP: ${pos.y} | LEFT: ${pos.x} | HEIGTH: ${pos.h} | WIDTH: ${pos.w}`,
            "rotate"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Rotate!\n${error}`);
        });
    },
    resize(pos) {
      this.vWidth = pos.w + "";
      this.vHeight = pos.h + "";
      let el = document.getElementById(`${this.ID}-svg-juncao`);
      el.style.width = `${this.vWidth}px`;
      el.style.height = `${this.vHeight}px`;
      let id = this.ID;
      datas
        .salvarTamanho(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | HEIGHT: ${pos.h} | WIDTH: ${pos.w} | ANGLE: ${pos.angle}`,
            "resize"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Resize!\n${error}`);
        });
    },
    drag(pos) {
      let id = this.ID;
      datas
        .salvarPosicao(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | TOP: ${pos.y} | LEFT: ${pos.x} | ANGLE: ${pos.angle}`,
            "drag"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Drag!\n${error}`);
        });
    }
  },
  mounted() {}
};
</script>

<style>
.componenteJuncao {
  position: absolute;
  height: 100px;
  width: 100px;
  cursor: move;
  z-index: 200;
}
</style>
